import moment from "moment";

const convertSize = value => {
  if (!value) return 0;
  return (+value / 1024).toFixed(2);
};

const activityDate = date => {
  if (!date) return "";
  return moment(date).format("hh:mm A YYYY/MM/DD");
};

const dateShared = date => {
  if (!date) return "";

  const locale = localStorage.getItem("locale")
    ? localStorage.getItem("locale")
    : "en";

  const translations = {
    en: {
      justNow: "Just now",
      today: "today",
      yesterday: "yesterday"
    },
    ja: {
      justNow: "たった今",
      today: "今日",
      yesterday: "昨日"
    }
  };

  const now = moment();
  const from = moment(date);
  const diffInMinutes = now.diff(from, "minutes");
  const diffInHours = now.diff(from, "hours");
  const qualifier =
    now.dayOfYear() === from.dayOfYear()
      ? translations[locale].today
      : translations[locale].yesterday;
  let dateShared = "";

  if (diffInMinutes <= 1) {
    dateShared = translations[locale].justNow;
  } else if (diffInHours > 48) {
    dateShared = `${moment(date).format("hh:mm A")} ${moment(date).format(
      "DD/MM/YYYY"
    )}`;
  } else {
    dateShared =
      locale === "en"
        ? `${moment(date).format("hh:mm A")} ${qualifier}`
        : `${qualifier} ${moment(date).format("hh:mm A")}`;
  }

  return dateShared;
};

const expireDays = date => {
  if (!date) return "";
  return moment(date).fromNow();
};

const emailName = value => {
  if (!value) return "";
  return value.split("@")[0];
};

const prettyExtention = name => {
  if (!name) return "Document";

  const extention = name.split(".")[1] ? name.split(".").pop() : "";

  let prettyName = "";

  if (extention) {
    switch (extention.toLowerCase()) {
      case "zip":
      case "rar":
      case "tar":
      case "gzip":
        prettyName = `${extention.toUpperCase()} Archive`;
        break;
      case "mp3":
      case "mpeg":
      case "wav":
      case "ogg":
      case "opus":
        prettyName = `${extention.toUpperCase()} Audio`;
        break;
      case "jpeg":
      case "jpg":
      case "png":
      case "gif":
      case "bmp":
      case "tiff":
      case "svg":
        prettyName = `${extention.toUpperCase()} Image`;
        break;
      case "html":
      case "css":
      case "php":
      case "c":
      case "cpp":
      case "h":
      case "hpp":
      case "js":
      case "java":
      case "py":
        prettyName = `${extention.toUpperCase()} Markup/Code`;
        break;
      case "txt":
        prettyName = `${extention.toUpperCase()} Text`;
        break;
      case "webm":
      case "mpeg4":
      case "3gpp":
      case "mov":
      case "avi":
      case "mpegps":
      case "wmv":
      case "flv":
        prettyName = `${extention.toUpperCase()} Video`;
        break;
      case "dfx":
        prettyName = `${extention.toUpperCase()} Autodesk AutoCad`;
        break;
      case "ai":
        prettyName = `${extention.toUpperCase()} Illustrator`;
        break;
      case "psd":
        prettyName = `${extention.toUpperCase()} Photoshop`;
        break;
      case "pdf":
        prettyName = `${extention.toUpperCase()} Portable Document`;
        break;
      case "ttf":
        prettyName = `${extention.toUpperCase()} TrueType`;
        break;
      case "eps":
      case "ps":
        prettyName = `${extention.toUpperCase()} PostScript`;
        break;
      case "xls":
      case "xlsx":
        prettyName = `${extention.toUpperCase()} Excel`;
        break;
      case "ppt":
      case "pptx":
        prettyName = `${extention.toUpperCase()} Powerpoint Presentation`;
        break;
      case "doc":
      case "docx":
        prettyName = `${extention.toUpperCase()} Word`;
        break;
      case "xps":
        prettyName = `${extention.toUpperCase()} XML Paper Specification`;
        break;
      case "key":
      case "numbers":
        prettyName = `${extention.toUpperCase()} Editor`;
        break;
      default:
        prettyName = `${extention.toUpperCase()} Document`;
    }
  } else {
    prettyName = "Document";
  }

  return prettyName;
};

const filters = {
  convertSize,
  expireDays,
  emailName,
  prettyExtention,
  dateShared,
  activityDate
};

export default filters;
